import { useContext } from 'react';
import { WhatsNewContext } from './WhatsNewContext.js';

/** The sidebar row's view of What's New: the unread count and a way to open the drawer. */
const useWhatsNew = () => {
    const context = useContext(WhatsNewContext);
    if (context === undefined) {
        throw new Error("useWhatsNew must be used within a WhatsNewProvider");
    }
    return context;
};
/** `null` outside a provider, which is how a surface hides itself while the feature flag is off. */
const useOptionalWhatsNew = () => { var _a; return (_a = useContext(WhatsNewContext)) !== null && _a !== void 0 ? _a : null; };

export { useOptionalWhatsNew, useWhatsNew };
